import { DatePicker } from 'antd';
import styled from 'styled-components';

const DatePickerStyled = styled(DatePicker)`
  min-width: 200px !important;
  max-width: 100%;
`;

export default DatePickerStyled;
